import React, {FunctionComponent, useEffect, useState} from 'react'
import style from './style.scss'
import {useTranslation} from 'react-i18next'
import OverviewTarget from './OverviewTarget/OverviewTarget'
import {IProps} from './IProps'

const OverviewContent: FunctionComponent<IProps> = ({period, targets, personRevenues}) => {
    const {t} = useTranslation()

    const filteredTargets = targets.filter(value => value.period === period)
    const [targetsForPeriod, setTargetsForPeriod] = useState(filteredTargets)

    useEffect(() => {
        const filteredTargets = targets.filter(value => value.period === period)

        setTargetsForPeriod(filteredTargets)
    }, [period])

    return (
        <div className={'page-layout large'}>
            <a href="/hr/targets/manage" className="button margin-bottom-large">{t('Manage')}</a>
            <h1>{t(`Targets overview`)} ({t(period)})</h1>
            <div>
                <ol className={style.overviewCategory}>
                    <div className={style.overviewLegend}>
                        <div className={style.leftColumn}>
                            <p className={style.boldAndUnderline2}>{t('Persons')}</p>
                        </div>
                        <div className={style.rightColumn1}>
                            <p className={style.boldAndUnderline2}>{t('amount')}</p>
                            <p className={style.boldAndUnderLineMobile2}>&euro;</p>
                        </div>
                        <div className={style.rightColumn2}>
                            <p className={style.boldAndUnderline2}>{t('percentage')}</p>
                            <p className={style.boldAndUnderLineMobile2}>%</p>
                        </div>
                    </div>
                    <div>
                        {targetsForPeriod.length >= 1
                            ? targetsForPeriod.map((value) => (
                                <OverviewTarget key={value.id} target={value} personRevenues={personRevenues}/>
                            )) : (
                                <p>{t('There are no targets for this period.')}</p>
                            )
                        }
                    </div>
                </ol>
            </div>
        </div>
    )
}

export default OverviewContent
